import { render, staticRenderFns } from "./new_payment_process_information.vue?vue&type=template&id=0368064e&scoped=true"
import script from "./new_payment_process_information.vue?vue&type=script&lang=js"
export * from "./new_payment_process_information.vue?vue&type=script&lang=js"
import style0 from "./new_payment_process_information.vue?vue&type=style&index=0&id=0368064e&prod&lang=scss"
import style1 from "./new_payment_process_information.vue?vue&type=style&index=1&id=0368064e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0368064e",
  null
  
)

export default component.exports